import { locationsURL } from '@root/components/locations/routes';

import { buildJSONLDBreadcrumbList } from '@utils/json_ld';

const ROOT_URL = 'https://www.clutter.com';

const BASE_LINKS = [
  { url: ROOT_URL, name: 'Clutter' },
  { url: ROOT_URL + locationsURL(), name: 'Locations' },
];

export const BASE_JSON_LD_BREADCRUMB_LIST =
  buildJSONLDBreadcrumbList(BASE_LINKS);
